import { render, staticRenderFns } from "./provideOrganizationInfoThird.vue?vue&type=template&id=c1bc1c1c&scoped=true&"
import script from "./provideOrganizationInfoThird.vue?vue&type=script&lang=js&"
export * from "./provideOrganizationInfoThird.vue?vue&type=script&lang=js&"
import style0 from "./provideOrganizationInfoThird.vue?vue&type=style&index=0&id=c1bc1c1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bc1c1c",
  null
  
)

export default component.exports